import { SET_LANDING_SHOWN } from "../constants/action-types";

export default (state = false, { type, landingShown }) => {
  if (type == SET_LANDING_SHOWN) {
    return landingShown;
  } else {
    return state;
  }
};
